@if (!dialogRef.componentInstance.loading) {
<div class="content">
  <div class="title">
    {{ data.component === "analytics" || data.component === "fm-analytics" ? "Export" : "Export DDQ" }}
  </div>
  @if (component === 'fm-review') {
  <div [ngClass]="{ 'disabled-item': includeDetailReport, 'option-container': true }">
    <button
      class="checkbox-container"
      (click)="includeSummaryReport = !includeSummaryReport"
      [disabled]="includeDetailReport"
    >
      <input type="checkbox" [checked]="includeSummaryReport" />
      <span class="checkmark"></span>
    </button>
    <span class="checkbox-label spacing"
      >Do you want to produce a summary report (includes executive summary and overview, and questionnaire
      ratings)?</span
    >
  </div>
  } @if (component === 'fm-review') {
  <div [ngClass]="{ 'disabled-item': includeSummaryReport, 'option-container': true }">
    <button
      class="checkbox-container"
      (click)="detailReportOptionClick('includeDetailReport')"
      [disabled]="includeSummaryReport"
    >
      <input type="checkbox" [checked]="includeDetailReport" />
      <span class="checkmark"></span>
    </button>
    <span class="checkbox-label spacing"
      >Do you want to produce a detailed report (includes summary report, overall questionnaire summary and all the
      questions)?</span
    >
  </div>
  } @if (component === 'fm-review') {
  <ul [ngClass]="{ 'disabled-item': includeSummaryReport }">
    <li class="option-container">
      <button
        class="checkbox-container"
        (click)="detailReportOptionClick('includeExtraData')"
        [disabled]="includeSummaryReport"
      >
        <input type="checkbox" [checked]="includeExtraData" />
        <span class="checkmark"></span>
      </button>
      <span class="checkbox-label spacing">Include flags, ratings, review comments and approval summary for DDQ</span>
    </li>
    <li class="option-container">
      <button
        class="checkbox-container"
        (click)="detailReportOptionClick('excludeComments')"
        [disabled]="includeSummaryReport"
      >
        <input type="checkbox" [checked]="excludeComments" />
        <span class="checkmark"></span>
      </button>
      <span class="checkbox-label spacing">Exclude additional comments to questions from distributor</span>
    </li>
  </ul>
  } @if (component === 'review') { @if (cycles) { @if (cycles && cycles.length !== 0) {
  <div class="cycle-select">
    <form class="custom-form">
      <div class="control-group">
        <div class="label">Version of DDQ Export</div>
        <div class="control-box">
          <ng-select
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="selectedCycleId"
            [closeOnSelect]="true"
            [multiple]="false"
            [items]="cycles"
            bindLabel="name"
            bindValue="id"
            placeholder="Click here to select version of DDQ export"
            appendTo=".mat-mdc-dialog-surface"
          >
          </ng-select>
        </div>
      </div>
    </form>
  </div>
  } @else {
  <div class="no-export-text">
    You don't have any available Due Diligence documents. Export will be enabled only after DDQ Release.
  </div>
  } } @else {
  <mat-progress-bar class="loading-cycles" mode="indeterminate"></mat-progress-bar>
  } } @if (component !== 'review' || (component === 'review' && cycles && cycles.length !== 0)) {
  <div class="password-protect-container">
    <button class="checkbox-container" (click)="changeCheckboxStatus()">
      <input type="checkbox" [checked]="checked" />
      <span class="checkmark"></span>
    </button>
    <span class="checkbox-label spacing">Do you want to password protect the report document?</span>
  </div>
  @if (checked) {
  <div class="custom-form">
    <div class="control-group">
      <div class="label">Enter Password</div>
      <div class="control-box">
        <input class="input-form" type="password" [formControl]="password" (keyup)="checkPasswordMatch()" />
      </div>
    </div>
    <div class="control-group">
      <div class="label">Repeat Password</div>
      <div class="control-box">
        <input class="input-form" type="password" [formControl]="repeatPassword" (keyup)="checkPasswordMatch()" />
      </div>
    </div>
    @if (showError) {
    <div class="error">Password confirmation doesn't match password</div>
    } @if (showSpaceSymbolError) {
    <div class="error">Space are not supported in the password</div>
    }
  </div>
  } }
  <div class="actions">
    <button class="ddd-button" (click)="dialogRef.close()">Cancel</button>
    <button
      class="ddd-button raised"
      (click)="submit()"
      [disabled]="showError || showSpaceSymbolError || (component === 'review' && !selectedCycleId)"
    >
      Export
    </button>
  </div>
</div>
} @else {
<div class="export-loader-text">
  Preparing your export, this could take a few seconds. The window will close automatically.
</div>
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
